import * as React from 'react';

function SvgMyProfile(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={30} height={29.995} {...props}>
      <path
        data-name="Path 5916"
        d="M15 29.994a15.007 15.007 0 0 1-15-14.99 15.01 15.01 0 0 1 15.015-15 15.007 15.007 0 0 1 14.985 15 15.007 15.007 0 0 1-15 14.99Zm0-13.175c-.947 0-1.894-.008-2.84 0a5.008 5.008 0 0 0-5.053 4.507 2.23 2.23 0 0 0 .741 2.113 10.863 10.863 0 0 0 6.218 2.581 10.84 10.84 0 0 0 7.272-1.969 5.734 5.734 0 0 0 1.155-1.02 2.432 2.432 0 0 0 .327-2.1 5 5 0 0 0-5.008-4.115h-2.807Zm4.959-7.386a4.964 4.964 0 0 0-4.968-4.941 4.961 4.961 0 0 0-4.957 4.95 4.981 4.981 0 0 0 4.981 4.964 4.982 4.982 0 0 0 4.948-4.973Z"
        fill="#051828"
      />
    </svg>
  );
}

export default SvgMyProfile;
